module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "scrollContainer",
    staticClass: "content category_list",
    staticStyle: {
      "top": "2.2rem"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "category_page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sort_filter"
  }, [_c('a', {
    staticClass: "category-open open-sort",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.opensort
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.sort")) + "  \n                        "), _c('span', {
    staticClass: "icon icon-caret"
  })]), _vm._v(" "), _c('a', {
    staticClass: "category-open open-filter",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.openfilter
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.filter")) + "  \n                        "), _c('span', {
    staticClass: "icon icon-caret"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " infinite-scroll infinite-scroll-bottom",
    attrs: {
      "data-distance": "10"
    }
  }, [_c('div', {
    staticClass: "list-block wrap"
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: " infinite-scroll infinite-scroll-bottom",
    attrs: {
      "data-distance": "100"
    }
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('div', {
    staticClass: "list-container"
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('div', {
      staticClass: "row"
    }, [(item.one) ? _c('div', {
      staticClass: "col-50 product_list"
    }, [_c('router-link', {
      attrs: {
        "to": item.one.url
      }
    }, [_c('img', {
      staticClass: "lazy",
      attrs: {
        "width": "100%",
        "src": item.one.image
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "product_name"
    }, [_c('router-link', {
      attrs: {
        "to": item.one.url
      }
    }, [_vm._v("\n                                            " + _vm._s(item.one.name) + "           \n                                          ")])], 1), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#333"
      }
    }), _c('p', {
      staticClass: "proPrice"
    }, [(item.one.special_price) ? _c('span', {
      staticClass: "bizhong"
    }, [_vm._v(_vm._s(item.one.special_price ? item.one.special_price.code : ''))]) : _vm._e(), _vm._v(" "), (item.one.special_price) ? _c('span', {
      staticClass: "my_shop_price f14",
      attrs: {
        "orgp": item.one.special_price
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.one.special_price ? item.one.special_price.symbol : ''))]), _vm._v("\n                                              " + _vm._s(item.one.special_price ? item.one.special_price.value : '') + "\n                                            ")]) : _vm._e(), _vm._v(" "), (!item.one.special_price) ? _c('span', {
      staticClass: "bizhong"
    }, [_vm._v(_vm._s(item.one.price ? item.one.price.code : ''))]) : _vm._e(), _vm._v(" "), (!item.one.special_price) ? _c('span', {
      staticClass: "my_shop_price f14",
      attrs: {
        "orgp": item.one.price
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.one.price ? item.one.price.symbol : ''))]), _vm._v("\n                                                " + _vm._s(item.one.price ? item.one.price.value : '') + "\n                                            ")]) : _vm._e(), _vm._v(" "), (item.one.special_price) ? _c('span', {
      staticClass: "bizhong"
    }, [_vm._v(_vm._s(item.one.price ? item.one.price.code : ''))]) : _vm._e(), _vm._v(" "), (item.one.special_price) ? _c('del', {
      staticClass: "my_shop_price",
      attrs: {
        "orgp": item.one.price
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.one.price ? item.one.price.symbol : ''))]), _vm._v("\n                                              " + _vm._s(item.one.price ? item.one.price.value : '') + "\n                                            ")]) : _vm._e()]), _vm._v(" "), _c('p')], 1) : _vm._e(), _vm._v(" "), (item.two.name) ? _c('div', {
      staticClass: "col-50 product_list"
    }, [_c('router-link', {
      attrs: {
        "to": item.two.url
      }
    }, [_c('img', {
      staticClass: "lazy",
      attrs: {
        "width": "100%",
        "src": item.two.image
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "product_name"
    }, [_c('router-link', {
      attrs: {
        "to": item.two.url
      }
    }, [_vm._v("\n                                            " + _vm._s(item.two.name) + "           \n                                          ")])], 1), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#333"
      }
    }), _c('p', {
      staticClass: "proPrice"
    }, [(item.two.special_price) ? _c('span', {
      staticClass: "bizhong"
    }, [_vm._v(_vm._s(item.two.special_price ? item.two.special_price.code : ''))]) : _vm._e(), _vm._v(" "), (item.two.special_price) ? _c('span', {
      staticClass: "my_shop_price f14",
      attrs: {
        "orgp": item.two.special_price
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.two.special_price ? item.two.special_price.symbol : ''))]), _vm._v("\n                                              " + _vm._s(item.two.special_price ? item.two.special_price.value : '') + "\n                                            ")]) : _vm._e(), _vm._v(" "), (!item.two.special_price) ? _c('span', {
      staticClass: "bizhong"
    }, [_vm._v(_vm._s(item.two.price ? item.two.price.code : ''))]) : _vm._e(), _vm._v(" "), (!item.two.special_price) ? _c('span', {
      staticClass: "my_shop_price f14",
      attrs: {
        "orgp": item.two.price
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.two.price ? item.two.price.symbol : ''))]), _vm._v("\n                                                " + _vm._s(item.two.price ? item.two.price.value : '') + "\n                                            ")]) : _vm._e(), _vm._v(" "), (item.two.special_price) ? _c('span', {
      staticClass: "bizhong"
    }, [_vm._v(_vm._s(item.two.price ? item.two.price.code : ''))]) : _vm._e(), _vm._v(" "), (item.two.special_price) ? _c('del', {
      staticClass: "my_shop_price",
      attrs: {
        "orgp": item.two.price
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_vm._v(_vm._s(item.two.price ? item.two.price.symbol : ''))]), _vm._v("\n                                              " + _vm._s(item.two.price ? item.two.price.value : '') + "\n                                            ")]) : _vm._e()]), _vm._v(" "), _c('p')], 1) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('mugen-scroll', {
    attrs: {
      "handler": _vm.fetchProduct,
      "should-handle": !_vm.loading,
      "scroll-container": "scrollContainer"
    }
  }, [_c('div', {
    staticClass: "infinite-scroll-preloader",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "preloader"
  })])])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup popup-filter"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(1), _vm._v(" "), (_vm.refine_by_info.length > 0) ? _c('div', {
    staticClass: "filter_refine_by"
  }, [_c('div', {
    staticClass: "filter_attr_title"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.refine_by")) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "filter_refine_by_content"
  }, _vm._l((_vm.refine_by_info), function(refine_item, refine_index) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.clearFilterAttr(refine_item.attr, refine_item.val, $event)
        }
      }
    }, [_c('i', {
      staticClass: "closeBtn c_tagbg"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(refine_item.val))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter_category && _vm.categoryInfo.name) ? _c('div', {
    staticClass: "category_left_filter_category"
  }, [_c('div', {
    staticClass: "filter_attr_title"
  }, [_vm._v("\n                    " + _vm._s(_vm.categoryInfo.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "filter_category_content"
  }, [(_vm.filter_category) ? _c('ul', _vm._l((_vm.filter_category), function(cate_item, cate_index) {
    return _c('li', {
      class: {
        current: cate_item.current
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/' + cate_item.url
      }
    }, [_vm._v("\n                                " + _vm._s(cate_item.name) + "        \n                            ")]), _vm._v(" "), (cate_item.child) ? _c('ul', _vm._l((cate_item.child), function(cate_child_item, cate_child_index) {
      return _c('li', {
        class: {
          current: cate_child_item.current
        }
      }, [_c('router-link', {
        attrs: {
          "to": '/' + cate_child_item.url
        }
      }, [_vm._v("\n                                        " + _vm._s(cate_child_item.name) + "        \n                                    ")])], 1)
    }), 0) : _vm._e()], 1)
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.filter_info) ? _c('div', {
    staticClass: "category_left_filter"
  }, _vm._l((_vm.filter_info), function(filter_items, filter_index) {
    return _c('div', {
      staticClass: "filter_attr"
    }, [_c('div', {
      staticClass: "filter_attr_title"
    }, [_vm._v("\n                        " + _vm._s(filter_items.label) + "\n                    ")]), _vm._v(" "), (filter_items.items) ? _c('div', {
      staticClass: "filter_attr_info"
    }, [_vm._l((filter_items.items), function(filter_item, filter_item_index) {
      return (filter_item._id) ? [_c('a', {
        class: {
          checked: filter_item.selected
        },
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.changeFilterAttr(filter_index, filter_item._id, filter_item.selected, $event)
          }
        }
      }, [_vm._v("\n                                " + _vm._s(filter_item.label) + "(" + _vm._s(filter_item.count) + ")\n                            ")]), _vm._v(" "), _c('br')] : _vm._e()
    })], 2) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.filter_price) ? _c('div', {
    staticClass: "category_left_filter"
  }, _vm._l((_vm.filter_price), function(price_items, price_index) {
    return _c('div', {
      staticClass: "filter_attr"
    }, [_c('div', {
      staticClass: "filter_attr_title"
    }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.price")) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "filter_attr_info"
    }, [_vm._l((price_items), function(price_item, price_item_index) {
      return [_c('a', {
        class: {
          checked: price_item.selected
        },
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.changeFilterPrice(price_item.val, price_item.selected, $event)
          }
        }
      }, [_vm._v("\n                                " + _vm._s(price_item.label) + "\n                            ")]), _vm._v(" "), _c('br')]
    })], 2)])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "popup popup-sort"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "tb_le"
  }, [(_vm.query_sort) ? _c('div', {
    staticClass: "category_left_filter"
  }, [_c('div', {
    staticClass: "filter_attr"
  }, [_c('div', {
    staticClass: "filter_attr_title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("message.sort_by")) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "filter_attr_info"
  }, [_vm._l((_vm.query_sort), function(sort_item, sort_index) {
    return [_c('a', {
      class: {
        checked: sort_item.selected
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.changeSort(sort_item.value, $event)
        }
      }
    }, [_vm._v(" \n                                            " + _vm._s(sort_item.label) + "\n                                        ")]), _vm._v(" "), _c('br')]
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category_img"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close_popup"
  }, [_c('a', {
    staticClass: "close-popup",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close_popup"
  }, [_c('a', {
    staticClass: "close-popup",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b01195a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/category/Index.vue
// module id = 255
// module chunks = 1